module.exports = __webpack_public_path__ + "img/fire.58e55d87.png";